
import createEditContact from "./createEditContact";


const ContactInformation = {
  createEditContact
};
export default ContactInformation;
